module.exports = __webpack_public_path__ + "img/gaku_text_08.af47989b.png";